import React, { FC } from 'react';
import { Route } from 'react-router';

import StandsTable from '../components/equipments-stands/table';
import StandEdit from '../components/equipments-stands/edit';

const EquipmentsStandsPage: FC = () => {
  return (
    <>
      <Route exact path="/equipments-stands/edit/:id" component={StandEdit} />
      <Route exact path="/equipments-stands" component={StandsTable} />
    </>
  );
};

export default EquipmentsStandsPage;
